/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Link_ExpiryInputs */

const en_password_reset_link_expiry = /** @type {(inputs: Password_Reset_Link_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link expires in 1 hour. Check your spam folder if you don't see it.`)
};

const es_password_reset_link_expiry = /** @type {(inputs: Password_Reset_Link_ExpiryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El enlace caduca en 1 hora. Si no lo ves, revisa la carpeta de spam.`)
};

/**
* | output |
* | --- |
* | "The link expires in 1 hour. Check your spam folder if you don't see it." |
*
* @param {Password_Reset_Link_ExpiryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_link_expiry = /** @type {((inputs?: Password_Reset_Link_ExpiryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Link_ExpiryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_link_expiry(inputs)
	return en_password_reset_link_expiry(inputs)
});